export default "__VITE_ASSET__57de6e41__"